<template>
  <FormFieldWrapper :data="data">
    <VAInput
      :modelValue="modelValue"
      @update:modelValue="handleInput"
      @blur="handleBlur"
      placeholder="Type your response here ..."
      :validateFunc="customValidation"
    />
  </FormFieldWrapper>
</template>

<script>
import FormFieldWrapper from './FormFieldWrapper.vue';

export default {
  name: 'ShortResponse',
  components: { FormFieldWrapper },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: ''
    },
    customValidation: {
      type: Function,
      default: null
    }
  },
  emits: ['update:modelValue', 'blur', 'validation-error'],
  methods: {
    handleInput(value) {
      this.$emit('update:modelValue', value);
    },
    handleBlur() {
      const value = this.modelValue;
      if (this.customValidation) {
        const error = this.customValidation(value);
        if (error) {
          this.$emit('validation-error', error);
        }
      }
      this.$emit('blur', value);
    }
  }
};
</script>

<style scoped>
</style>
